import {_axios as axios} from  "../../plugins/axios.js";
import kit from "../../plugins/kit.js"

import { Message, MessageBox  } from "element-ui";
import i18nKit from "../../plugins/I18N.js"
import Auth from "../../plugins/auth.js"

let api = kit.api;
let i18n = i18nKit.methods;
let auth = Auth.methods;

/**
 * 获取详情数据list
 * @param {*} query StockDetailListQuery 查询条件
 * @param {*} resultCall 如果有数据就会回调这个函数
 * @param {*} loadingChange 是否加载中的回调函数
 */
const getData = function(query, resultCall, loadingChange, hist){

    if(loadingChange){
        loadingChange(true)
    }
    // console.log(_this.ids)
    console.log('请求地址：',api.stockDetail.listByStock+"?hist="+hist)
    axios.post(api.stockDetail.listByStock+"?hist="+hist, 
        query
    ).then((result) => {
        if(loadingChange){
            loadingChange(false)
        }
        // Message(result.msg);
        
        if(result.status){ 
            let ds = result.data.list;
            let total = result.data.total;
            ds.forEach(d => {
                d.details.forEach(dd => {
                    d['checked'] = dd.innerExpCode && dd.shelfCode;
                    if(!dd.storeId){
                        dd.storeId = 0;
                    }
                    d['purchaseLink'] = null;
                    // d['hasLink'] = dd.purchaseId>0?1:0;
                });
            });
            var resultList = [];
            for (let i = 0; i < ds.length; i++) {
                var newObj = {};
                newObj = deepCloneMore(ds[i], null);
                if (newObj.details != null && newObj.details.length > 0) {
                    for (let j = 0; j < newObj.details.length; j++) {
                        if (j == 0) {
                            newObj.detail = newObj.details[j];
                            newObj.detailIndex = 0;
                            resultList.push(newObj);
                        } else {
                            var tmp = {};
                            tmp = deepCloneMore(ds[i], null);
                            tmp.detail = newObj.details[j];
                            tmp.detailIndex = j;
                            resultList.push(tmp);
                        }
                    }
                } else {
                    newObj.detail = {};
                    resultList.push(newObj);
                }
            }
            if(resultCall){
                resultCall(resultList, total)
            }
        }
    }).catch(err => {
        if(loadingChange){
            loadingChange(false)
        }
    });
}

/**
 * 合并单元格
 * @param {*} dataTableRef this.$refs.dataTable 要合并的表格
 * @param {*} mergeFields : eg: mergeFields: ['code'],  //要合并的字段
 * @returns 
 */
const mergeRow = function(dataTableRef, mergeFields){
    var data = dataTableRef.getTableData();
    var visibleData = data.tableData;

    //页面刚刚初始化完成，无法获取到visiableData,所有默认去总数据里面取10条
    if (visibleData.length <= 1) {
        visibleData = data.visibleData.slice(0, 10);
    }
    //开始计算合并的位置
    var offset = dataTableRef.getVTRowIndex(visibleData[0]);

    const fields = mergeFields;
    var mergeCellResult = [];
    if (fields.length == 0) {
        return mergeCellResult;
    }
    var allColumns = dataTableRef.getColumns();
    var columnNames = allColumns.map(x => x.property);
    for (var i = 0; i < fields.length; i++) {
        var property = fields[i];
        var rowIndex = 0;
        var colIndexes = findAllOccurrences(columnNames, property);
        if (colIndexes.length <= 0) {
            continue;
        }
        while (rowIndex < visibleData.length) {
            var row = visibleData[rowIndex];
            const cellValue = row[property];
            var rowspan = 1;
            var startIndex = rowIndex;
            if (cellValue != undefined && cellValue != null) {
                let nextRow = visibleData[rowIndex + 1];
                while (nextRow && nextRow[property] == row[property]) {
                    rowIndex++;
                    nextRow = visibleData[rowIndex + 1];
                    rowspan++;
                }
            }
            if (rowspan > 1) {
                for (var p = 0; p < colIndexes.length; p++) {
                    mergeCellResult.push({row: offset + startIndex, col: colIndexes[p], rowspan: rowspan});
                }
                rowspan = 1;
            }
            rowIndex++;
        }
    }
    return mergeCellResult;
}

 /**
  * 根据列名，查找所有的索引。
  * @param {*} arr 
  * @param {*} item 
  * @returns 
  */
const findAllOccurrences = function(arr, item){
    var subArr = [];
    for(var i = 0; i < arr.length; i++){
        if(arr[i] === item){
            subArr.push(i);
        }
    }
    return subArr;
}

/**
 * 深度复制对象
 * @param {*} obj 
 * @param {*} result 
 */
const deepCloneMore = function(obj, result){
    var oClass = isClass(obj)
    if (result == null) {
        if (oClass === 'Object') {
            result = {}
        } else if (oClass === 'Array') {
            result = []
        } else {
            return obj
        }
    }
    for (var key in obj) {
        if(result[key]!=null) {
            continue;
        }
        var copy = obj[key]
        if (isClass(copy) === 'Object') {
            result[key] = deepCloneMore(copy)// 递归调用
        } else if (isClass(copy) === 'Array') {
            result[key] = deepCloneMore(copy)
        } else {
            result[key] = obj[key]
        }
    }
    return result
}

/**
 * 判断是否对象
 * @param {Object} o 
 * @returns 
 */
const isClass = function(o){
    if (o === null) return 'Null'
    if (o === undefined) return 'Undefined'
    return Object.prototype.toString.call(o).slice(8, -1)
}

/**
 * 获取该用户的仓库
 */
const getStores = function(resultCall){
    axios.post(
        api.store.listUsed
    ).then((result)=> {
        let store = null;
        if(result.status){
            let data = result.data;
            data.splice(0, 0, {id: 0, name: '默认仓库'});
            store = data;
        }else{
            store = [
                {id: 0, name: '默认仓库'},
                // {id: 1, name: '默认仓库1'},
            ]
        }
        if(resultCall){
            resultCall(store)
        }
    });
}

/**
 * 更新保单备注，更新货单备注
 * @param {*} stock 
 * @param {*} type 1-报单备注, else-货单备注
 * @param {*} refreshList 
 * @returns 
 */
const updateRemark = function(stock, type, refreshList){
    if(!auth.hasPermission("stock:detailEdit")){
        Message(i18n.msg('无操作权限'));
        return;
    }

    let remark1 = stock.remark1;
    let remark2 = stock.remark2;

    let label = "";
    if(type == 1){
        label = '请输入报单备注（'+remark1+'）';
    }else{
        label = '请输入货单备注（'+remark2+'）';
    }

    MessageBox.prompt(label, i18n.msg('提示'), {
        confirmButtonText: i18n.msg('确定'),
        cancelButtonText: i18n.msg('取消'),
    }).then(({ value }) => {
        if(value && value.length > 100){
            Message(i18n.msg('备注超长，请控制在100字内'));
            return;
        }
        axios.post(
            api.stock.updateRemark
                +"?t="+type
                +"&id="+stock.id, value?value:''
        ).then((result) => {
            if(result.status){
                if(refreshList){
                    refreshList();
                }
                Message(result.msg);
            }else{
                Message(i18n.msg('已打单不能更新货单备注'));
            }
        });
    }).catch(() => {
        Message({
            type: 'info',
            message: '取消输入'
        });
    });
}

/**
 * 更新1-商家平台, 2-信用代码
 * @param {*} stock 
 * @param {*} type 1-商家平台, 2-信用代码
 * @param {*} refreshList 
 * @returns 
 */
const updateStorePlatform = function(stock, type, refreshList){
    // if(!auth.hasPermission("stock:detailEdit")){
    //     Message(i18n.msg('无操作权限'));
    //     return;
    // }

    let remark1 = stock.storePlatform=='alibaba'?'1688':stock.storePlatform;
    let remark2 = stock.creditCode;

    let label = "";
    if(type == 1){
        label = '请输入商家平台（'+remark1+'）';
    }else{
        label = '请输入信用代码（'+remark2+'）';
    }

    MessageBox.prompt(label, i18n.msg('提示'), {
        confirmButtonText: i18n.msg('确定'),
        cancelButtonText: i18n.msg('取消'),
    }).then(({ value }) => {
        if(value && value.length > 10 && type == 1){
            Message(i18n.msg('商家平台超长，请控制在10字内'));
            return;
        }
        if(value && type == 2){
            if(value.length > 18){
                Message(i18n.msg('信用代码超长，请控制在18字内'));
                return;
            }
            const creditCodeRegex = /^[A-Z0-9]{18}$/;
            if(!creditCodeRegex.test(value)){
                Message(i18n.msg('信用代码格式错误，请输入18位大写字母和数字的组合'));
                return;
            }
        }
        axios.post(
            api.stock.updatePlatFormAndCredit
                +"?t="+type
                +"&id="+stock.id, value?value:''
        ).then((result) => {
            if(result.status){
                if(refreshList){
                    refreshList();
                }
                Message(result.msg);
            }else{
                Message(i18n.msg('已打单不能更新货单备注'));
            }
        });
    }).catch(() => {
        Message({
            type: 'info',
            message: '取消输入'
        });
    });
}

/**
 * 更新快递单号，更新架位号
 * @param {*} stock {id}
 * @param {*} stockDetail {id, storeId, innerExpCode, shelfCode}
 * @param {*} username 当前登录的用户名
 * @param {*} type 0-快递单号，1-货架号
 * @param {*} refreshList 刷新表格的回调
 * @returns 
 */
const updateCode = function(stock, stockDetail,username, type, refreshList){
    if(!auth.hasPermission("stock:detailEdit")){
        Message(i18n.msg('无操作权限'));
        return;
    }
    // if(!stockDetaill.detail)

    // 这段代码好像永远都不会执行
    // if(!stockDetail.storeId && stockDetail.storeId != 0){
    //     Message(i18n.msg('请选择仓库'));
    //     return;
    // }
    if(stockDetail.shelfCode){
        Message("请先删除转寄单号回撤库存");
        return;
    }
 
    if((stock.status >= 23 && stock.status != 79) || stock.status == 10){
        Message("打单后的订单不能更新");
        return;
    }
    if((stock.status < 23 || stock.status == 79) && stock.status != 10 || username != "admin"){
        let label = "";
        let warningText = i18n.msg('提示：需要分包的快递请在后面加好备注说明');
        if(type === 0){
            // label = i18n.msg('请输入快递单号');
            label = i18n.msg('请输入快递单号：')+'<br/>'+"<span style='color:red;'>"+warningText+"</span>";
        }else{
            label = i18n.msg('请输入货架号')+'<br/>'+"<span style='color:red;'>"+warningText+"</span>";
        }

        MessageBox.prompt(label, i18n.msg('提示'), {
            closeOnClickModal:false,
            dangerouslyUseHTMLString: true,
            confirmButtonText: i18n.msg('确定'),
            cancelButtonText: i18n.msg('取消'),
        }).then(({ value }) => {
            axios.post(api.stockDetail.updateDetailCode
                +"?t="+type
                +"&id="+stock.id
                +"&detailId="+stockDetail.id
                +"&code="+(value?value:"")
            ).then((result) => {
                // if(result.status){
                //     }
                if(refreshList){
                    refreshList();
                }
                Message(result.msg);
            });
        }).catch(() => {
            Message({
                type: 'info',
                message: '取消输入'
            });
        });
    }else{
        Message("打单后的订单不能更新");
    }

    //下面重新获取stock信息是保证数据的正确性，
    //但是我觉的没有必要，因为在后台也做了这个逻辑的验证
    // axios.post(
    //     api.stock.getStockById+"?id="+stock.id
    // ).then((result) => {
    //     let resultStock = result.data;
    //     if(resultStock.status == 20){
    //         Message("请先删除快递单号！");
    //         return;
    //     }
    //     if((resultStock.status >= 23 && resultStock.status != 79) || resultStock.status == 10){
    //         Message("打单后的订单不能更新");
    //         return;
    //     }
    //     if((resultStock.status < 23 || resultStock.status == 79) && resultStock.status != 10 || username != "admin"){
    //         let label = "";
    //         if(type === 0){
    //             label = i18n.msg('请输入快递单号')+"("+stockDetail.innerExpCode+")"
    //         }else{
    //             label = i18n.msg('请输入货架号')+"("+stockDetail.shelfCode+")"
    //         }

    //         MessageBox.prompt(label, i18n.msg('提示'), {
    //             closeOnClickModal:false,
    //             confirmButtonText: i18n.msg('确定'),
    //             cancelButtonText: i18n.msg('取消'),
    //         }).then(({ value }) => {
    //             axios.post(api.stockDetail.updateDetailCode
    //                 +"?t="+type
    //                 +"&id="+stock.id
    //                 +"&detailId="+stockDetail.id
    //                 +"&code="+(value?value:"")
    //             ).then((result) => {
    //                 // if(result.status){
    //                 //     }
    //                 if(refreshList){
    //                     refreshList();
    //                 }
    //                 Message(result.msg);
    //             });
    //         }).catch(() => {
    //             Message({
    //                 type: 'info',
    //                 message: '取消输入'
    //             });
    //         });
    //     }else{
    //         Message("打单后的订单不能更新");
    //     }
    // });
}
/**
 * 更新快递单号，更新架位号
 * @param {*} stock {id}
 * @param {*} stockDetail {id, storeId, innerExpCode, shelfCode}
 * @param {*} username 当前登录的用户名
 * @param {*} type 0-快递单号，1-货架号
 * @param {*} refreshList 刷新表格的回调
 * @returns 
 */
const updateQty = function(stockId, detailId, refreshList){
    if(!auth.hasPermission("stock:detailEdit")){
        Message(i18n.msg('无操作权限'));
        return;
    }
    
    MessageBox.prompt("更新数量", i18n.msg('提示'), {
        closeOnClickModal:false,
        confirmButtonText: i18n.msg('确定'),
        cancelButtonText: i18n.msg('取消'),
    }).then(({ value }) => {

        if(value <= 0){
            Message("数量不正确");
            return;
        }

        axios.post(api.stockDetail.updateQty
            +"?qty="+value
            +"&id="+stockId
            +"&detailId="+detailId
        ).then((result) => {
            // if(result.status){
            //     }
            if(refreshList){
                refreshList();
            }
            Message(result.msg);
        });
    }).catch(() => {
        Message({
            type: 'info',
            message: '取消输入'
        });
    });
}

const updateProductName = function(stockId, productName, refreshList){
    if(!auth.hasPermission("stock:batchFieldRemark2")){
        Message(i18n.msg('无操作权限'));
        return;
    }
    
    MessageBox.prompt("更新品名："+productName, i18n.msg('提示'), {
        closeOnClickModal:false,
        confirmButtonText: i18n.msg('确定'),
        cancelButtonText: i18n.msg('取消'),
    }).then(({ value }) => {

        axios.post(api.stockDetail.updateProductName
            +"?productName="+value
            +"&id="+stockId
        ).then((result) => {
            if(refreshList){
                refreshList();
            }
            Message(result.msg);
        });
    }).catch(() => {
        Message({
            type: 'info',
            message: '取消输入'
        });
    });
}

/**
 * 选择到货仓库
 * @param {*} detailId 
 * @param {*} storeId 
 * @param {*} type 1-选择到货仓库
 * @param {*} refreshList 刷新表格的回调
 * @returns 
 */
const selectedStore = function(detailId, storeId, type, refreshList){
    if(!auth.hasPermission("stock:detailEdit")){
        Message(i18n.msg('无操作权限'));
        return;
    }
    axios.post(api.stockDetail.updateDetailStore
        +"?detailId="+detailId
        +"&storeId="+storeId
    ).then((result) => {
        if(result.status && refreshList){
            refreshList();
        }
        Message(result.msg);
    });
}

/**
 * 删除快递单号
 * @param {*} vue 
 * @param {*} rowIndex 
 * @param {*} detailIndex 
 * @returns 
 */
const deleteInnerCode = function(detailId, refreshList){
    if(!auth.hasPermission("stock:detailEdit")){
        Message(i18n.msg('无操作权限'));
        return;
    }
    MessageBox.confirm(i18n.msg('确定要清除快递单号和货架号吗？'), i18n.msg('提示'), {
        confirmButtonText: i18n.msg('确定'),
        cancelButtonText: i18n.msg('取消'),
        type: 'warning'
    }).then(() => {
        axios.get(
            api.stockDetail.deleteInnerCode+"?detailId="+detailId
        ).then((result) => {
            if(result.status){
                if(refreshList){
                    refreshList();
                }
                Message(result.msg || i18n.msg("清除成功"));
            }else{
                Message(result.msg || i18n.msg("清除失败"));
            }
        });
    }).catch((err) => {
        // console.log(err);
        Message({
            type: 'info',
            message: '取消'
        });
    });
}

/**
 * 点到
 * @param {*} vue 
 * @param {*} rowIndex 
 * @param {*} detailIndex 
 * @param {*} markVal 
 * @returns 
 */
const updateMark = function(stockId, stockDetailId, markVal, refreshList){
    if(!auth.hasPermission("stock:detailEdit")){
        Message(i18n.msg('无操作权限'));
        return;
    }
    let label = "";
    let mark = -1;
    if(markVal === 1){
        mark = 1;
        label = i18n.msg('确定要点到吗')
    }else{
        mark = 0;
        label = i18n.msg('确定要取消点到吗')
    }

    MessageBox.confirm(label, i18n.msg('点到确认'), {
        confirmButtonText: i18n.msg('确定'),
        cancelButtonText: i18n.msg('取消'),
    }).then(() => {
        axios.post(api.stockDetail.updateDetailMark
            +"?t="+mark
            +"&id="+stockId
            +"&detailId="+stockDetailId
        ).then((result) => {
            if(result.status && refreshList){
                refreshList();
            }
            Message(result.msg);
        });
    }).catch(() => {
        // if(refreshList){
        //     refreshList();
        // }
        Message({
            type: 'info',
            message: i18n.msg('取消'),
        });
    });
}

/**
 * 新增一条详情
 * @param {*} stockId 
 * @param {*} changeAddDetailVisiable function(visiable) 
 * @returns 
 */
const addDetail = function(stockId, changeAddDetailVisiable){
    if(!auth.hasPermission("stock:detailEdit")){
        Message(i18n.msg('无操作权限'));
        return;
    }
    axios.post(
        api.stock.selectStatusById+"?stockId="+stockId
    ).then((result) => {
        if(result.status){
            let data = result.data;
            if(data){
                if(data.status >= 13 && data.status <= 23 && data.status != 20){
                    changeAddDetailVisiable(true);
                }else{
                    if(auth.hasPermission("stock:detailAdd")){
                        changeAddDetailVisiable(true);
                    }else{
                        Message(i18n.msg('该订单不能新增'));
                    }
                }
            }else{
                Message(i18n.msg('无效数据'));
            }
        }
    });
}

/**
 * 打开采购链接
 * @param {*} stock 
 * @param {*} stockDetail 
 * @param {*} callback 
 * @returns 
 */
const openBuyLink = function(stock, stockDetail, callback){
    let user = JSON.parse(localStorage.getItem("user"));

    if(user.deptPath.indexOf('/1/6262/2') > -1){
        //圣捷下面的客户只需要有会员就可以
        if(!user.vip || user.vip == 0){
            Message(i18n('没有权限或非超级会员，不能进行快捷采购！'));
            return;
        }
    }else{
        if(!auth.hasPermission("stock:detailPurchase")){
            Message(i18n.msg('没有权限或非超级会员，不能进行快捷采购！'));
            return;
        }
    }
    
    // if(!auth.hasPermission("stock:detailPurchase")){
    //     Message(i18n.msg('没有权限或非超级会员，不能进行快捷采购！'));
    //     return;
    // }

    //根据详情标题，搜索采购链接表，查找对应链接
    //如果找到，则打开新链接
    //如果没找到，则提示输入链接
    axios.post(
        api.stockDetail.openBuyLink
        +"?id="+stock.id
        +"&detailId="+stockDetail.id
        +"&purchaseLink="+(stockDetail.purchaseLink?encodeURIComponent(stockDetail.purchaseLink):'')
    ).then((result) => {
        if(result.status){
            window.open(result.data,"_blank")
            //弹出一个新页面
            if(callback){
                callback();
            }
        }else{
            MessageBox.alert(i18n.msg('未匹配到采购链接，请自行输入链接后再次采购'), i18n.msg('提示'), {
                confirmButtonText: i18n.msg('确定'),
            });
        }
    });
}

/**
 * 保存采购单号
 * @param {*} stockId 
 * @param {*} stockDetail 
 * @param {*} refreshList 
 * @returns 
 */
const savePurchaseCode = function(stockId, stockDetail, refreshList){
    let user = JSON.parse(localStorage.getItem("user"));

    if(user.deptPath.indexOf('/1/6262/2') > -1){
        //圣捷下面的客户只需要有会员就可以
        if(!user.vip || user.vip == 0){
            Message(i18n('没有权限或非超级会员，不能进行快捷采购！'));
            return;
        }
    }else{
        if(!auth.hasPermission("stock:detailPurchase")){
            Message(i18n.msg('没有权限或非超级会员，不能进行快捷采购！'));
            return;
        }
    }

    // if(!auth.hasPermission("stock:detailPurchase")){
    //     Message(i18n.msg('没有权限或非超级会员，不能进行快捷采购！'));
    //     return;
    // }

    if(!stockDetail.purchaseCode){
        Message(i18n.msg('采购单号不存在'));
        return;
    }
    if(!stockDetail.purchasePlatform){
        Message(i18n.msg('请选择采购平台'));
        return;
    }

    let cost = 0;
    let resCost = stockDetail.cost;
    if(resCost){
        cost = (resCost*100).toFixed(0);
    }

    axios.post(api.stockDetail.updateDetailPurchaseCode
            +"?code="+stockDetail.purchaseCode
            +"&type="+stockDetail.purchasePlatform
            +"&created="+stockDetail.purchaseTime
            +"&cost="+cost
            +"&id="+stockId
            +"&detailId="+stockDetail.id
        ).then((result) => {
            if(result.status && refreshList){
                refreshList();
            }
            Message(result.msg);
        });

    // MessageBox.confirm(i18n.msg('保存采购单号？'), i18n.msg('提示'), 
    // {
    //     confirmButtonText: i18n.msg('确定'),
    //     cancelButtonText: i18n.msg('取消'),
    // }).then(() => {
    //     axios.post(api.stockDetail.updateDetailPurchaseCode
    //         +"?code="+stockDetail.purchaseCode
    //         +"&type="+stockDetail.purchasePlatform
    //         +"&created="+stockDetail.purchaseTime
    //         +"&cost="+cost
    //         +"&id="+stockId
    //         +"&detailId="+stockDetail.id
    //     ).then((result) => {
    //         if(result.status && refreshList){
    //             refreshList();
    //         }
    //         Message(result.msg);
    //     });
    // }).catch(() => {
    //     // if(refreshList){
    //     //     refreshList();
    //     // }
    //     Message({
    //         type: 'info',
    //         message: i18n.msg('取消'),
    //     });
    // });
}

/**
 * 撤销已采购单号
 * @param {*} stockId 
 * @param {*} stockDetailId 
 * @param {*} refreshList 
 */
const rebackPurchaseCode = function(stockId, stockDetailId, reefreshList){

    MessageBox.confirm(i18n.msg('撤销已采购单号？'), i18n.msg('提示'), {
        confirmButtonText: i18n.msg('确定'),
        cancelButtonText: i18n.msg('取消'),
    }).then(() => {
        axios.post(api.stockDetail.rebackDetailPurchaseCode
            +"?id="+stockId
            +"&detailId="+stockDetailId
        ).then((result) => {
            if(result.status){
                if(reefreshList){
                    reefreshList()
                }
                Message(result.msg);
            }else{
                Message(i18n.msg('请先删除快递单号'));
            }
        });
    }).catch(() => {
        // if(reefreshList){
        //     reefreshList()
        // }
        Message({
            type: 'info',
            message: i18n.msg('取消'),
        });
    });
}

/**
 * 图片上传的回调函数
 * 图片上传成功后将id设置到详情中
 * @param {*} result 
 * @param {*} rowIndex 
 * @param {*} detailIndex 
 */
const uploadProductPhotoCallback = function(
    res,
    detailId,
    callback
){
    if(res.status){
        //保存图片ID
        axios.post(
            api.stock.detailThumb+'?detailId='+detailId+'&thumbId='+res.data
        ).then((result) => {
            if(result.status){
                if(callback){
                    callback()
                }
                Message("上传成功");
            }else{
                Message(i18n.msg('上传失败'));
            }
        });
    }else{
        Message("上传失败");
    }
}

const OrderService = {
    getData: getData,
    mergeRow: mergeRow,
    getStores: getStores,
    updateRemark: updateRemark,
    updateStorePlatform:updateStorePlatform,
    updateCode: updateCode,
    selectedStore:selectedStore,
    deleteInnerCode:  deleteInnerCode,
    updateMark: updateMark,
    addDetail: addDetail,
    openBuyLink: openBuyLink,
    savePurchaseCode:savePurchaseCode,
    rebackPurchaseCode:rebackPurchaseCode,
    uploadProductPhotoCallback: uploadProductPhotoCallback,
    updateQty:updateQty,
    updateProductName:updateProductName,
}


export default OrderService